// apps/share-web/src/song-screen/song-head.ts
//
// Шапка телефонного экрана песни: ✕ (звук стоп, назад туда, откуда пришёл),
// название + мета, справа — выбор версии прямо в шапке, как в десктопе
// (комментарий Сергея к v4), и ⋯.
import { iconButton } from '../chart/chart-buttons.js';
import { t } from '../ui/i18n.js';
import '../styles/song-screen.css';

export interface SongHeadDeps {
  title: string;
  meta: string;
  onClose: () => void;
  onMore: () => void;
  mountVersionActions?: (host: HTMLElement) => { unmount(): void };
}
export interface SongHeadHandle { destroy(): void; }

export function mountSongHead(host: Element, d: SongHeadDeps): SongHeadHandle {
  const root = document.createElement('div');
  root.className = 'ss-head';
  const close = iconButton({ glyph: '✕', name: t('songScreen.close'), size: 'lg', cls: 'ss-head-close', onClick: d.onClose });
  const tm = document.createElement('div');
  tm.className = 'ss-head-tm';
  const h = document.createElement('h1');
  h.className = 'ss-head-title';
  h.textContent = d.title;
  const m = document.createElement('span');
  m.className = 'ss-head-meta';
  m.textContent = d.meta;
  tm.appendChild(h);
  tm.appendChild(m);
  const actions = document.createElement('div');
  actions.className = 'ss-head-actions';
  const versions = d.mountVersionActions?.(actions);
  actions.appendChild(iconButton({ glyph: '⋯', name: t('songScreen.more'), size: 'lg', cls: 'ss-head-more', onClick: d.onMore }));
  root.appendChild(close);
  root.appendChild(tm);
  root.appendChild(actions);
  host.appendChild(root);
  return { destroy() { versions?.unmount(); root.remove(); } };
}
